// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21Sqf","signatureBlock":"Footer_signatureBlock__3_mxV","signature":"Footer_signature__2yBZR"};